import { cn } from "@/lib/utils";

interface IconProps {
  className?: string;
}

/** Rounded avatar silhouette with subtle smile — replaces User */
export function IconAvatar({ className }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("h-4 w-4", className)}
      aria-hidden="true"
    >
      {/* Head */}
      <circle cx="12" cy="8.5" r="4" />
      {/* Subtle smile */}
      <path d="M10.5 9.5C10.8 10 11.4 10.3 12 10.3C12.6 10.3 13.2 10 13.5 9.5" />
      {/* Shoulders — organic curve */}
      <path d="M4 21C4 17.13 7.58 14 12 14C16.42 14 20 17.13 20 21" />
    </svg>
  );
}
